import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import PostCard from '@/components/BlogPage/PostsList/GridView/PostCard';
import { BlogPostDto } from '@/components/BlogPage/types';
import css from './style.module.scss';
interface Props {
  posts: BlogPostDto[];
  showTags?: boolean;
  setIsCustomCursorVisible?: (value: boolean) => void;
}
const GridView: FC<Props> = t0 => {
  const $ = _c(9);
  const {
    posts,
    showTags: t1,
    setIsCustomCursorVisible
  } = t0;
  const showTags = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== posts || $[1] !== setIsCustomCursorVisible || $[2] !== showTags) {
    let t3;
    if ($[4] !== setIsCustomCursorVisible || $[5] !== showTags) {
      t3 = post => <PostCard key={post.id} post={post} className="post-item" data-flip-id={post.id} showTags={showTags} setIsCustomCursorVisible={setIsCustomCursorVisible} />;
      $[4] = setIsCustomCursorVisible;
      $[5] = showTags;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = posts.map(t3);
    $[0] = posts;
    $[1] = setIsCustomCursorVisible;
    $[2] = showTags;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className={css.grid}>{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default GridView;